import { HTMLAttributes, useContext } from 'react';
import './InfoBoxImage.scss';
import { PiImageSquareLight } from 'react-icons/pi';
import { InfoBoxContext } from '../../InfoBox';
import { ImageInput } from 'components/atoms';
import { IImageInputProps } from 'components/atoms/inputs/image/ImageInput';

export interface IInfoBoxImageProps extends IImageInputProps {
  size?: boolean;
}

const InfoBoxImage = ({ size = false, ...props }: IInfoBoxImageProps) => {
  const { loading } = useContext(InfoBoxContext);
  return (
    <div className={`info-box-image ${size  ? 'small' : ''}`}>
      <ImageInput {...props} loading={loading} />
    </div>
  );
};

export default InfoBoxImage;
